import Vue from 'vue'

Vue.component('form-group', () => import('./FormGroup'))